import { BaseProvider } from 'src/app/core/services/base-provider';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "../../../core/services/ls-helper.service";
import * as i4 from "../../../core/services/auth.service";
import * as i5 from "../../../core/services/utils.service";
export class TransactionAdminRevisionStatusInternalService extends BaseProvider {
    constructor(globals, http, ls, authService, utilsService) {
        super();
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.authService = authService;
        this.utilsService = utilsService;
        this.term = '';
        this.list = [];
        this.hasUnfinalizedRevisions = false;
        this.baseUrl = "revisionInternal";
    }
    getRevisionStatusLog(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/get/userProcess/' + params.userProcessId +
                '/requirement/' + params.requirementId;
            this.http
                .get(this.url)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getUnfinalizedRevisionStatus(userProcessId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/unfinalized/userProcess/' + userProcessId;
            this.http
                .get(this.url)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    createRevisionStatusLog(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/userProcess/' + params.userProcessId +
                '/requirement/' + params.requirementId;
            this.http
                .post(this.url, params)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    finalizeRevisionStatusLog(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/finalize/userProcess/' + params.userProcessId +
                '/requirement/' + params.requirementId;
            this.http
                .put(this.url, params)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    deleteRevisionStatusLog(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/delete/userProcess/' + params.userProcessId +
                '/requirement/' + params.requirementId;
            this.http
                .delete(this.url)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
}
TransactionAdminRevisionStatusInternalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TransactionAdminRevisionStatusInternalService_Factory() { return new TransactionAdminRevisionStatusInternalService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LsHelperService), i0.ɵɵinject(i4.AuthService), i0.ɵɵinject(i5.UtilsService)); }, token: TransactionAdminRevisionStatusInternalService, providedIn: "root" });
